import MDBox from "components/MDBox"
import MDButton from "components/MDButton";
import TableSkeleton from "components/TableSkeleton";
import { useEffect, useMemo, useState } from "react"
import { useMaterialUIController, setLoading } from "context";
import { useForm } from "react-hook-form";
import DataTable from "examples/Tables/DataTable";
import permissions from "permissions";
import { CircularProgress } from "@mui/material";
import { OcMasterAPI } from "api/OcMasterAPI";


export default function OcMasterTable(props) {

  const [ocMaster, setOcMaster] = useState([]);
  const [controller, dispatch] = useMaterialUIController();
  const { user, loading, admin } = controller;
  const { handleSubmit, formState: { isSubmitting } } = useForm();
  const { handleAlert } = props

  const currencyformatter = new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
  });

  const numberFormater = new Intl.NumberFormat();

  const renderOcMaster = useMemo(() => {
    let rows = [];
    const columns = [
      { Header: "Código", accessor: "codigo", align: "right" },
      { Header: "Cantidad", accessor: "cantidad", align: "right", },
      { Header: "Valor Unitario", accessor: "valor_unitario", align: "right" },
      { Header: "Código Proveedor", accessor: "codigo_proveedor", align: "right" },
      { Header: "Nombre Proveedor", accessor: "nombre_proveedor", align: "right" }
    ];

    ocMaster?.map((element) => {
      rows = [...rows,
      {
        codigo: element.codigo,
        cantidad: element.cantidad,
        valor_unitario: currencyformatter.format(Number(element.valor_unitario).toFixed(2)),
        codigo_proveedor: element.codigo_proveedor,
        nombre_proveedor: element.nombre_proveedor
      }]
    });

    return (<DataTable
      table={{ columns, rows }}
      isSorted={true}
      entriesPerPage={true}
      showTotalEntries={true}
      noEndBorder
      canSearch={true}
    />
    );
  }, [ocMaster])


  const getOcMaster = () => {
    setLoading(dispatch, true)
    return OcMasterAPI.index(true)
      .then(response => {
        setOcMaster(response.oc_master)
      }).catch(error => {
        if (error.response) {
          handleAlert(error.response.data.message, 'error')
        }
      }).finally(() => {
        setLoading(dispatch, false)
      });
  }


  return (
    <MDBox>
      <MDBox sx={{ display: 'flex', flexDirection: 'row-reverse', p: 3 }} component="form" role="form" onSubmit={handleSubmit(getOcMaster)}>
        {(user?.permissions?.includes(permissions.product_arrays[1]) || user?.role === admin) && (
          <MDButton type="submit" variant="gradient" color="info" disabled={isSubmitting}>
            {isSubmitting ? <CircularProgress size={18} color="white" /> : 'Consultar Maestro OC'}
          </MDButton>
        )}
      </MDBox>
      <MDBox>
        {loading ? <TableSkeleton></TableSkeleton> : renderOcMaster}
      </MDBox>
    </MDBox>
  )

}